import axios from 'axios'

export const postHelp = (data) => {
  return axios.post('contact/helpcenter', data)
    .then(res => res)
    .catch(err => {
      console.log('err', err)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/contact.api.js